import { Outlet } from 'react-router-dom'
import { appLogoUrl, partnerAppName, tenantName } from '@/lib/tenant'

export function OnboardingLayout() {
  return (
    <div className="min-h-screen bg-[var(--ink-50)] flex flex-col items-center">
      {/* Header */}
      <div className="w-full max-w-[800px] px-6 pt-6 pb-4">
        <div className="flex items-center gap-2.5">
          <img
            src={appLogoUrl()}
            alt={tenantName()}
            className="w-7 h-7 object-contain"
            style={{ borderRadius: 6 }}
          />
          <span className="text-[15px] font-bold tracking-tight text-[var(--ink-950)]">
            {partnerAppName()}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="w-full max-w-[800px] px-6 pb-12 flex-1">
        <Outlet />
      </div>
    </div>
  )
}
